import React from "react";

interface EmptyStateProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  // Variant rather than a className override: two competing padding classes
  // would be resolved by stylesheet order, not prop order.
  padding?: "none" | "sm" | "md";
}

const PADDING: Record<NonNullable<EmptyStateProps["padding"]>, string> = {
  none: "",
  sm: "py-8",
  md: "py-12",
};

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  padding = "md",
}) => {
  return (
    <div className={`text-center ${PADDING[padding]}`}>
      <Icon className="mx-auto mb-4 h-12 w-12 text-gray-400" />
      <h3 className="mb-1 text-lg font-medium text-gray-900 dark:text-white">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {description}
        </p>
      )}
    </div>
  );
};

export default EmptyState;
